/* eslint-disable */

import Vue from "vue";
import i18n from "@/i18n/index.js";
import axios from "axios";
import store from "@/store";
import { date, Screen, colors, Platform } from "quasar";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import { WCAG_COLORS } from "./accessibilityColors";
import _camelCase from "lodash.camelcase";


export function $http(params) {
    return new Promise((resolve, reject) => {
        axios({
            method: params.type || "POST",
            url: params.url,
            data: params.data || null,
            headers: params.headers || {},
            responseType: params.responseType || null
        })
            .then(rsp => {
                store().dispatch("userProfile/saveCookieInfo");

                resolve(rsp);
            })
            .catch(err => {
                let message = "Could not complete action";

                if (err.response && err.response.data && err.response.data.error) {
                    message = err.response.data.error;
                }

                if (err.response && err.response.data && err.response.data.exceptionMessage) {
                    message = err.response.data.exceptionMessage;
                }

                if (err.response && err.response.data && err.response.data.error === "Forbidden" && !err.response.data.path.includes("permissions")) {
                    message = "";
                    sessionStorage.setItem("sessionExpired", true);
                    window.location.assign("/login");
                }

                if (!params.noNotify && message) {
                    Vue.prototype.$toast.showNotify({
                        type: "error",
                        message
                    });
                }

                reject(err);
            });
    });
}

export const eventBus = new Vue();

const checkBrowser = () => {
    const usrAgent = navigator.userAgent || navigator.vendor || window.opera;
    let browser = "";

    if (usrAgent.indexOf("Firefox") > -1) {
        browser = "firefox";
    } else if (usrAgent.indexOf("SamsungBrowser") > -1) {
        browser = "samsung";
    } else if (usrAgent.indexOf("Opera") > -1 || usrAgent.indexOf("OPR") > -1) {
        browser = "opera";
    } else if (usrAgent.indexOf("Trident") > -1) {
        browser = "msie";
    } else if (usrAgent.indexOf("Edge") > -1 || usrAgent.indexOf("Edg") > -1) {
        browser = "edge";
    } else if (usrAgent.indexOf("Chrome") > -1) {
        browser = "chrome";
    } else if (usrAgent.indexOf("Safari") > -1) {
        browser = "safari";
    }

    return browser;
}

const validateCondition = (strCondition) => {
    const auxList = ["firefox", "samsung", "opera", "msie", "edge", "chrome", "safari"];
    const safeCondition = (strCondition || "").split(",").filter(entry => entry);
    const browser = checkBrowser();

    return safeCondition.length && safeCondition.every(entry => {
        const negation = entry.startsWith("!");
        let logicalValue;

        if (negation) {
            entry = entry.substring(1);
        }

        logicalValue = auxList.includes(entry) ? entry === browser : Platform.is[entry] || Platform.has[entry] || Platform.within[entry]

        return negation ? !logicalValue : logicalValue;
    });
};

export const isValidBrowser = () => {
    let isValid = true;
    const safeWhite = getDynamicEnvValue("BROWSER_WHITELIST") || "";
    const safeBlack = getDynamicEnvValue("BROWSER_BLACKLIST") || "";

    if (safeWhite !== "") {
        isValid = safeWhite.split("|").some(validateCondition);
    } else if (safeBlack !== "") {
        isValid = !safeBlack.split("|").some(validateCondition);
    }

    return isValid;
};

export const isValidPlatform = () => {
    let isValid = true;
    const safeWhite = getDynamicEnvValue("PLATFORM_WHITELIST") || "";
    const safeBlack = getDynamicEnvValue("PLATFORM_BLACKLIST") || "";

    if (safeWhite !== "") {
        isValid = safeWhite.split("|").some(validateCondition);
    } else if (safeBlack !== "") {
        isValid = !safeBlack.split("|").some(validateCondition);
    }

    return isValid;
};

export const validBrowserMessage = () => {
    const browserMessage = getDynamicEnvValue("BROWSER_MESSAGE") || "chrome|edge|firefox";
    const conditions = browserMessage.split("|");
    const browserList = [];
    const shortNamePairs = {
        chrome: "Google Chrome", firefox: "Firefox", edge: "Microsoft Edge", ie: "Microsoft Internet", opera: "Opera"
    };

    conditions.forEach(browserCondition => {
        if (browserCondition.includes("-")) {
            const condition = browserCondition.split("-");
            if (condition[1] === "" || validateCondition(condition[1])) {
                browserList.push(...condition[0].split(",").filter(entry => entry));
            }
        } else {
            browserList.push(...browserCondition.split(",").filter(entry => entry));
        }
    });

    return [...new Set(browserList)].map(browser => shortNamePairs[browser]).join(", ");
};

export const validPlatformMessage = () => {
    const platformMessage = getDynamicEnvValue("PLATFORM_MESSAGE") || "win|mac|android";
    const conditions = platformMessage.split("|");
    const platformList = [];
    const shortNamePairs = {
        win: "Windows", mac: "MacOS", linux: "Linux", android: "Android", blackberry: "Blackberry",
        cros: "Chrome OS", ios: "iOS", ipad: "iPad", iphone: "iPhone", kindle: "Kindle"
    };

    conditions.forEach(platformCondition => {
        if (platformCondition.includes("-")) {
            const condition = platformCondition.split("-");
            if (condition[1] === "" || validateCondition(condition[1])) {
                platformList.push(...condition[0].split(",").filter(entry => entry));
            }
        } else {
            platformList.push(...platformCondition.split(",").filter(entry => entry));
        }
    });

    return [...new Set(platformList)].map(browser => shortNamePairs[browser]).join(", ");
};

export function getDynamicEnvValue(name) {
    const { configs } = window || {};

    const envDefaults = {
        UPLOAD_LIMIT_GUI: "50MB",
        UPLOAD_LIMIT_IDENTITY: "50MB",
        UPLOAD_LIMIT_ENGINE: "50MB",
        UPLOAD_LIMIT_DATA: "50MB",
        UPLOAD_LIMIT_AVATAR: "2MB",
        UPLOAD_LIMIT_DOCUMENT: "50MB",
        UPLOAD_LIMIT_INTEGRATION: "50MB",
        UPLOAD_LIMIT_GDM: "10MB",
        UPLOAD_LIMIT_DATASTORE: "100MB",
        UPLOAD_LIMIT_SAML: "5MB",
        UPLOAD_LIMIT_SSL: "5MB",
        UPLOAD_LIMIT_BULK_INVITE: "30KB",
        UPLOAD_LIMIT_USER_AVATAR: "100KB",
        UPLOAD_LIMIT_NAVIGATION_LOGO: "2MB",
        UPLOAD_LIMIT_BUILDER_AREA_LOGO:"2MB",
        UPLOAD_LIMIT_LOGIN_AREA_LOGO: "2MB",
        UPLOAD_LIMIT_APP_PLACEHOLDER: "128KB",
        UPLOAD_LIMIT_FAVICON: "2MB",
        UPLOAD_LIMIT_APP_AVATAR: "2MB",
        UPLOAD_LIMIT_UI_IMAGE: "25MB",
        UPLOAD_LIMIT_MEDIA_CAPTURE: "25MB",
        UPLOAD_LIMIT_DOC_BUILDER_PIC: "25MB"
    };

    return (configs && configs[name]) || envDefaults[name] || null;
}

export function getDynamicEnv(name) {
    const value = getDynamicEnvValue(name);
    let size = null;
    let bytesSize = null;

    if (value) {
        size = parseInt(value.slice(0, -2), 10);
        bytesSize = size * 1024;
        if (value.endsWith("MB")) {
            bytesSize *= 1024;
        }
    }

    return { size, value, bytesSize };
}

export function updateWindowTitle(title) {
    if (title && document.title !== title) {
        document.title = title;
    }
}

export function cardsContainer() {
    const classes = ["row"];
    if (Screen.lt.md) {
        classes.push(...["col-12", "q-py-xl"]);
    } else {
        classes.push(...["col-auto", "q-pa-lg"]);
    }

    return classes;
}

export function styleContainer() {
    const style = {
        height: "463px"
    };

    if (!Screen.lt.md) {
        style.width = "320px";
    }
    return style;
}

export const formatStr = (str, ...values) => {
    if (str && values.length) {
        values.forEach((key, idx) => {
            str = str.replace(new RegExp(`\\{${idx}\\}`, "gi"), key);
        });
    }

    return str;
};

export function getWeekOfMonth(date) {
    const month = date.getMonth();
    const year = date.getFullYear();
    const firstWeekday = new Date(year, month, 1).getDay();
    const lastDateOfMonth = new Date(year, month + 1, 0).getDate();
    const offsetDate = date.getDate() + firstWeekday - 1;
    const index = 1; // start index at 0 or 1, your choice
    const weeksInMonth = index + Math.ceil((lastDateOfMonth + firstWeekday - 7) / 7);
    const week = index + Math.floor(offsetDate / 7);

    if (week < 2 + index) {
        return week;
    }
    return week === weeksInMonth ? index + 5 : week;
}

export function readCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

export function eraseCookie(name) {
    createCookie(name, "", -1);
}

export function decodeUnicodeEscapes(text) {
    return text.replace(/\\u([0-9a-fA-F]{4})/g, function(match, grp) {
      return String.fromCharCode(parseInt(grp, 16));
    });
}

export function createCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires}; path=/`;
}

export function getVariableSyntax(source, fieldType) {
    let variableStart = "${(";
    let variableEnd = "";

    if (source === "MOD") {
        variableStart = "${(m_";
    } else if (source === "VAR") {
        variableStart = "${(s_";
    }

    switch (fieldType.toLowerCase()) {
        case "boolean":
            variableEnd = '?c)!}';
            break;
        case "integer":
            variableEnd = "?c)!}";
            break;
        case "decimal":
            variableEnd = '?c)!}';
            break;
        default:
            variableEnd = ")!}";
    }

    return { variableStart, variableEnd };
}
export function setPluginIconColor(activityType) {
    const mappings = {
        API_PLUGIN: "#444444",
        EXTERNAL_PLUGIN: "#F2BD46",
        APPROVALLEVEL_PLUGIN: "#BF4AE2",
        APPROVAL_PLUGIN: "#BF4AE2",
        BLOCKCHAIN_PLUGIN: "#DE6F25",
        TASK_PLUGIN: "#256BDE ",
        GENERATE_DOCUMENT_PLUGIN: "#00B55B",
        EXPOSE_API_PLUGIN: "#444444",
        GENERAL_START_PLUGIN: "#63D471",
        EXTERNAL_SOURCE_PLUGIN: "#256BDE",
        START_BLOCKCHAIN_EVENT_PLUGIN: "#63D471",
        GENERAL_END_PLUGIN: "#D15656",
        BLOCKCHAIN_EVENT_PLUGIN: "#DE6F25",
        DATA_EXPORT_PLUGIN: "#2DA9B4",
        PROCESS_PLUGIN: "#256BDE",
        ADVANCED_LOGIC_PLUGIN: "#6C7483"
    };
    const color = mappings[activityType] || "#256BDE";

    return `background-color: ${color}`;
}

export function setPluginIcon(activity) {
    let icon = "";
    if (activity) {
        let activityType = activity.pluginType || activity;
        if (activityType === "APPROVALLEVEL_PLUGIN") {
            activityType = "APPROVAL_PLUGIN";
        }
        icon = require(`@/assets/images/ActivitiesIcons/syncfusion/leftPanel/${activityType}.svg`);
    } else if (this.activity && this.activity.notificationRules) {
        icon = require("@/assets/images/ConnectorIcon.svg");
    }
    return icon;
}

export function convertAndFormatTimeToLocal(data, formatType) {
    if (data && formatType) {
        if (data.includes("+000")) {
            data = data.substring(0, data.length - 5);
        } else if (data.includes("+00:00")) {
            data = data.replace("+00:00", "");
        }
        const jsDate = new Date(data);
        const newDate = new Date(jsDate.getTime() + jsDate.getTimezoneOffset() * 60 * 1000);
        const offset = jsDate.getTimezoneOffset() / 60;
        const hours = jsDate.getHours();
        newDate.setHours(hours - offset);
        let localFormattedDate = date.formatDate(newDate, formatType);
        if (localFormattedDate && formatType === APP_DATE_DOT_FORMAT) {
            localFormattedDate = localFormattedDate.replace(/ /g, ` ${i18n.t("admin.processInspector.at")} `);
        }
        return localFormattedDate;
    }
}

export function getActualDateTime() {
    const date = new Date();

    // Get hours and minutes
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    // Get day, month, and year
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();

    // Return formatted string
    return `${hours}:${minutes} ${day}-${month}-${year}`;
}

// format date method which ADDS offset for search purposes to BE
export function formatTimeToSend(data, formatType) {
    const dateObj = new Date(data);
    const newDate = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000);
    const offset = dateObj.getTimezoneOffset() / 60;
    const hours = dateObj.getHours();
    newDate.setHours(hours + offset);
    return date.formatDate(newDate, formatType);
}

export function downloadFile(filename, fileType, data) {
    const blob = new Blob([data], { type: fileType });
    const a = document.createElement("a");
    let url = URL.createObjectURL(blob);
    a.href = url;
    a.setAttribute("download", filename);
    document.body.appendChild(a);
    a.click();
    url = URL.revokeObjectURL(url);
}

export function downloadFileZipIos(fileType, data) {
    const reader = new FileReader();
    const out = new Blob([data], { type: fileType });
    reader.onloadend = function (e) {
        window.location.href = reader.result;
    };
    reader.readAsDataURL(out);
}

export function downloadZipDesktop(fileType, data) {
    const blob = new Blob([data.data], { type: fileType });
    const aTag = document.createElement("a");
    let url = URL.createObjectURL(blob);
    aTag.href = url;
    aTag.click();
    url = URL.revokeObjectURL(url);
}

export function copyToClipboard(data, notificationMsg) {
    if (data) {
        const el = document.createElement("textarea");
        const isRTL = document.documentElement.getAttribute("dir") === "rtl";
        el.value = data;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style[isRTL ? "right" : "left"] = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        showNotification(notificationMsg);
    }
}
function showNotification(notificationMsg) {
    Vue.prototype.$toast.showNotify({
        type: "info",
        message: notificationMsg ? notificationMsg : i18n.t("admin.authentication.copyClipboard"),
        timeout: 4000
    });
}
// don't mix these 2
// used for Design & Configure business elements -permission (does not include publish permisssion)
export function editProcessPermissions(item, getCurrentAppUserPermissions) {
    let hasRights = false;
    const permissions = item.permission || getCurrentAppUserPermissions;
    if (permissions) {
        if (permissions.hasOwnProperty("g")) {
            hasRights = permissions.g === "o";
        } else {
            hasRights = Object.keys(permissions).find(uiCode => uiCode === "DI" && permissions[uiCode].g === "w");
        }
    }
    return hasRights;
}

// used for Publish App Permission (only owners & users with this permission can publish the app)
export function publishAppPermissions(item, getCurrentAppUserPermissions) {
    let hasRights = false;
    const permissions = getCurrentAppUserPermissions || item.permission;
    if (permissions) {
        if (permissions.hasOwnProperty("g")) {
            hasRights = permissions.g === "o";
        } else {
            hasRights = Object.keys(permissions).find(uiCode => uiCode === "PA" && permissions[uiCode].g === "w");
        }
    }
    return hasRights;
}

export function downloadErrorCode(data, fileName) {
    const fileType = "text/plain";
    let url;
    const blob = new Blob([data], { type: fileType });
    const aTag = document.createElement("a");
    url = URL.createObjectURL(blob);
    aTag.href = url;
    if (fileName) {
        aTag.download = fileName;
    } else {
        aTag.download = "Error";
    }
    document.body.appendChild(aTag);
    aTag.click();
    setTimeout(() => {
        document.body.removeChild(aTag);
        window.URL.revokeObjectURL(url);
    }, 0);
}

export function previewDocument(value, previewWindow) {
    const fileType = "application/pdf";
    const blob = new Blob([value.data], { type: fileType });
    const pdfObject = document.createElement("object");
    pdfObject.setAttribute("type", fileType);
    pdfObject.setAttribute("data", URL.createObjectURL(blob));
    pdfObject.style.cssText = "width:100%;height:100%;position:fixed;top:0;bottom:0;left:0;right:0;";
    previewWindow.document.body.append(pdfObject);
}

export function previewDocumentMobile(value) {
    const fileType = "application/pdf";
    const blob = new Blob([value.data], { type: fileType });
    const pdfObject = document.createElement("object");
    pdfObject.setAttribute("type", fileType);
    pdfObject.setAttribute("data", URL.createObjectURL(blob));
    pdfObject.style.cssText = "width:100%;height:100%;position:fixed;top:0;bottom:0;left:0;right:0;";
    window.open(pdfObject.data);
}

export function checkPermissionsApp(data, code) {
    let hasPermissions;
    let readonly;
    let owner;
    const permissionsData = {};
    const hasDataViewRights = (v) => Object.entries(v.DP).find(([, val]) => val.PP);
    if (data && code) {
        if (data.hasOwnProperty("g") && data.g === "o") {
            owner = true;
        } else if (Array.isArray(code)) {
            for (let i = 0; i < code.length; i++) {
                const permissions = data.hasOwnProperty(code[i]) && data[code[i]].hasOwnProperty("g");
                if (permissions) {
                    hasPermissions = true;
                    permissionsData[code[i]] = data[code[i]].g;
                }
            }
        } else if (typeof code === "object") {
            if (data.hasOwnProperty(code.parent)) {
                if (data[code.parent].hasOwnProperty("g")) {
                    hasPermissions = true;
                    readonly = data[code.parent].g === "r";
                } else if (code.child && Array.isArray(code.child)) {
                    const checkForReallocate = () => {
                        let isAvailable = true;
                        if (code.parent === "RP" && data.RP) {
                            isAvailable = !(Object.keys(data.RP).length === 2 && data.RP.RT && data.RP.UC);
                        }
                        return isAvailable;
                    }
                    if (checkForReallocate()) {
                        code.child.forEach(element => {
                            hasPermissions = true;
                            if (data[code.parent][element] && data[code.parent][element].g) {
                                permissionsData[element] = data[code.parent][element].g;
                            }
                        });
                    }
                } else if (Object.keys(data[code.parent]).length && data[code.parent].hasOwnProperty(code.child)) {
                    hasPermissions = true;
                    readonly = data[code.parent][code.child].g === "r";
                }
            }
        } else if (data.hasOwnProperty(code)) {
            if (data[code].hasOwnProperty("g")) {
                hasPermissions = true;
                readonly = data[code].g === "r";
            } else if (code === "DP" && Object.keys(data[code]).length && hasDataViewRights(data)) {
                const checkForReallocate = (v, type) => {
                    if (v[type] && v[type].g) {
                        permissionsData[type] = v[type].g;
                    }
                }
                if (data.RP) {
                    checkForReallocate(data.RP, "RT");
                    checkForReallocate(data.RP, "UC");
                }
                hasPermissions = true;
                readonly = false;
            }
        }
    }
    return owner ? { owner } : hasPermissions ? { readonly, permissionsData } : null;
}
export function staticBadgeStyle(staticBadge) {
    let staticBadgeStyle = "border-color: #2F3A4C; background-color: #ffffff; color: #2F3A4C";
    switch (staticBadge) {
        case "DATE":
        case "TIME":
        case "DTM":
            staticBadgeStyle = "border-color: #4AA8E2; background-color: #ffffff; color: #4AA8E2";
            break;
        case "INT":
            staticBadgeStyle = "border-color: #2E4B78; background-color: #ffffff; color: #2E4B78";
            break;
        case "BOOL":
            staticBadgeStyle = "border-color: #6F7681; background-color: #ffffff; color: #6F7681";
            break;
        case "DEC":
            staticBadgeStyle = "border-color: #2E7875; background-color: #ffffff; color: #2E7875";
            break;
        case "ATT":
            staticBadgeStyle = "border-color: #00B55B; background-color: #ffffff; color: #00B55B";
            break;
        case "MOD":
            staticBadgeStyle = "border-color: #BF4AE2; background-color: #ffffff; color: #BF4AE2";
            break;
        case "LOG":
            staticBadgeStyle = "border-color: #5CB85C; background-color: #ffffff; color: #5CB85C";
            break;
    }
    return staticBadgeStyle;
}

export function allowAccessibilityColors(wcagType) {
    const { setBrand } = colors;
    const getColor = (v) => {
        const { defaultColor, wcagColor } = v;
        return wcagType ? wcagColor : defaultColor;
    };
    Object.entries(WCAG_COLORS).forEach(([key, value]) => {
        setBrand(key, getColor(value));
    });
}

export function camelCase(str) {
    // return str.toLowerCase()
    //     .replace(/[-_]+/g, " ")
    //     .replace(/[^\w\s]/g, "")
    //     .replace(/ (.)/g, ($1) => $1.toUpperCase())
    //     .replace(/ /g, "");
    return _camelCase(str);
}

export function infoToastPublish(data) {
    if (!sessionStorage.getItem("wsActionUser") && data.id === store().getters["main/getCurrentApplicationId"]) {
        store().getters["apps/currentApp"].publishStatus = "PUBLISHED";
        Vue.prototype.$toast.showNotify({
            type: "info",
            message: i18n.t("apps.beenPublished"),
            caption: `${i18n.t("apps.by")} ${data.data.split(":")[2]}`
        });
    }
    sessionStorage.removeItem("wsActionUser");
}

export function sanitizeString(text = "", replacement = "_") {
    const illegalRe = /[\/\?<>\\:\*\|":]/g;
    const controlRe = /[\x00-\x1f\x80-\x9f]/g;
    const reservedRe = /^\.+$/;
    const windowsReservedRe = /^(con|prn|aux|nul|com[0-9]|lpt[0-9])(\..*)?$/i;

    const truncate = (sanitized, length) => {
        const uint8Array = new TextEncoder().encode(sanitized);
        const truncated = uint8Array.slice(0, length);

        return new TextDecoder().decode(truncated);
    }

    const sanitized = text
        .replace(illegalRe, replacement)
        .replace(controlRe, replacement)
        .replace(reservedRe, replacement)
        .replace(windowsReservedRe, replacement);

    return truncate(sanitized, 255);
}

export const isObject = (obj) => Object.prototype.toString.call(obj) === "[object Object]";

export const isNumeric = (str) => !isNaN(str) && !isNaN(parseFloat(str));

export const setOne = (obj, pathStr, value) => {
    const path = Array.isArray(pathStr) ? pathStr : splitPath(pathStr);
    const length = path.length;
    const lastIndex = length - 1;

    for (let index = 0; index < length; index++) {
        const prop = path[index];

        // If we are not on the last index, we start building the data object from the path
        if (index !== lastIndex) {
            const objValue = obj[prop];

            // If objValue exists, is not primitive and is not observable, then make it so using Vue.set
            if (objValue && typeof objValue === "object") {
                if (!objValue.hasOwnProperty("__ob__")) {
                    Vue.set(obj, prop, objValue);
                }
                // Check if parent path is an array, we are not on the last item and the next key in the path is not a number
                if (Array.isArray(objValue) && !isNumeric(path[index + 1])) {
                    Vue.set(obj, prop, {});
                }
            } else {
                // Create an empty object or an empty array based on the next path entry
                if (isNumeric(path[index + 1])) {
                    Vue.set(obj, prop, []);
                } else {
                    Vue.set(obj, prop, {});
                }
            }
        } else {
            // If we are on the last index then we just assign the value to the data object
            Vue.set(obj, prop, value);
        }
        obj = obj[prop];
    }
}

export const setMany = (obj, path, value) => {
    if (typeof path === "string") {
        setOne(obj, path, value);
    } else if (isObject(path)) {
        for (const key in path) {
            setOne(obj, key, path[key]);
        }
    } else {
        throw Error("Arguments must be either string or object.")
    }
}

export const deleteOne = (obj, pathStr) => {
    const path = Array.isArray(pathStr) ? pathStr : splitPath(pathStr);
    const prop = path.pop();

    Vue.delete(getByPath(obj, path), prop);
}

export const deleteMany = (obj, path) => {
    if (typeof path === "string") {
        deleteOne(obj, path);
    } else if (Array.isArray(path)) {
        path.forEach((item) => {
            deleteOne(obj, item);
        })
    } else {
        throw Error('Arguments must be either string or array.')
    }
}